// This re-exports ReadableStream with a static method `from`, if the method is
// not already present. Unfortunately typescript's dom library types the global
// `ReadableStream` as a var and not just an interface, so we can't just extend
// and merge the global declarations.
const ReadableStreamWithFrom = 'from' in ReadableStream
    ? ReadableStream
    : Object.assign(ReadableStream, {
        from(iterable) {
            if (iterable instanceof ReadableStream) {
                return iterable;
            }
            else if (Symbol.iterator in iterable) {
                const it = iterable[Symbol.iterator]();
                return new ReadableStream({
                    pull(cont) {
                        const result = it.next();
                        if (result.done) {
                            cont.close();
                        }
                        else {
                            cont.enqueue(result.value);
                        }
                    },
                });
            }
            else if (Symbol.asyncIterator in iterable) {
                const it = iterable[Symbol.asyncIterator]();
                return new ReadableStream({
                    async pull(cont) {
                        const result = await it.next();
                        if (result.done) {
                            cont.close();
                        }
                        else {
                            cont.enqueue(result.value);
                        }
                    },
                });
            }
            else {
                throw TypeError('Not iterable');
            }
        },
    });
export default ReadableStreamWithFrom;
